






































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader } from '@/components'
import { TableListHoliday } from '@/components/config'

// services
import { HolidayService } from '@/services/config'

// utils
import { loading, alerts } from '@/utils'

// models
import { HolidayForm, HolidayModel } from '@/models/config'
import { BvModalEvent } from 'bootstrap-vue'

// views
import ModalCreateEditHoliday from './modalCreateEdit.vue'

const newItem: HolidayForm = {
  description: '',
  month: null,
  day: null,
  year: null,
  repeat_yearly: false,
  is_active: true,
  date: null
}

@Component({
  name: 'HolidayIndex',
  components: {
    PageHeader,
    TableListHoliday,
    ModalCreateEditHoliday
  }
})
export default class HolidayIndex extends Vue {
  showModal = false
  holiday: HolidayForm = newItem
  title = 'Días Festivos'
  actionForm = 'save'
  idItemEdit: number|null = null
  items = [
    {
      text: 'Dashboard'
    },
    {
      text: 'Días Festivos',
      active: true
    }
  ]

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  addNew () {
    this.idItemEdit = null
    this.actionForm = 'save'
    this.holiday = newItem
    this.showModal = true
  }

  editItem (item: HolidayModel) {
    this.holiday = {
      description: item.description,
      date: item.date,
      month: item.month,
      day: item.day,
      year: item.year,
      repeat_yearly: item.repeat_yearly,
      is_active: item.is_active
    }
    if (item.id) {
      this.idItemEdit = Number(item.id)
    }
    this.actionForm = 'update'
    this.showModal = true
  }

  async deleteItem (item: HolidayModel) {
    const msg = `Seguro que desea eliminar el Día Festivo: ${item.description}`
    const confirm = await alerts.confirm(msg)
    if (confirm && item.id) {
      loading('show')
      await HolidayService.delete(item.id)
      alerts.success()
      this.tableList.getHolidaysWithPagination()
      loading('hide')
    }
  }

  async changeStatus (info: {id: number; status: boolean}) {
    loading('show')
    try {
      await HolidayService.changeStatus(info.id, info.status)
      alerts.success()
      this.tableList.getHolidaysWithPagination()
    } catch (e) {
      alerts.error()
    }
    loading('hide')
  }

  get tableList (): Vue & { getHolidaysWithPagination: () => void } {
    return this.$refs.table_list as Vue & { getHolidaysWithPagination: () => void }
  }

  get itemInit (): HolidayForm {
      return newItem
  }
}
